import { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism'
import { Box, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckIcon from '@mui/icons-material/Check'

const CodeBlock = ({ language, code }: { language: string; code: string }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    void navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }

  return (
    <Box sx={{ position: 'relative', my: 1 }}>
      <Tooltip title={copied ? 'Kopiert' : 'Kopieren'}>
        <IconButton
          size="small"
          onClick={handleCopy}
          sx={{ position: 'absolute', top: 4, right: 4, color: 'grey.400' }}
        >
          {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
        </IconButton>
      </Tooltip>
      <SyntaxHighlighter language={language} style={oneDark} customStyle={{ borderRadius: 8 }}>
        {code}
      </SyntaxHighlighter>
    </Box>
  )
}

export const MarkdownContent = ({ content }: { content: string }) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    components={{
      code: (props) => {
        const { className, children } = props
        const match = /language-(\w+)/.exec(className ?? '')
        const code = String(children).replace(/\n$/, '')
        return match ? (
          <CodeBlock language={match[1]} code={code} />
        ) : (
          <code className={className}>{children}</code>
        )
      },
    }}
  >
    {content}
  </ReactMarkdown>
)
